import * as Yup from "yup";

import { Form, Formik } from "formik";
import { useCallback, useContext, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { StoreContext } from "../../store";
import useTranslation from "next-translate/useTranslation";
import { DateField, PhoneField, Section, SubmitButton, TextField } from "@microrealestate/commonui/components";
import { Button, Grid } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import { AddBox } from "@material-ui/icons";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const validationSchema = (t) =>
  Yup.object().shape({
    name: Yup.string().required(t("Name is a required field")),
    whatsapp: Yup.string()
      .required(t("Whatsapp is a required field"))
      .test("is-valid-whatsapp", t("Whatsapp must be at least 9 characters"), (value) => {
        if (!value) return false;
        const phoneNumber = parsePhoneNumberFromString(value);
        if (!phoneNumber) return false;
        const nationalNumber = phoneNumber.nationalNumber || "";
        return nationalNumber.length >= 9;
      }),
    // taxIdNumber: Yup.number().moreThan(0).required(),
  });

const AccountSettings = observer(({ onSubmit, onSubmitted }) => {
  const store = useContext(StoreContext);
  const { t } = useTranslation("common");

  const initialValues = useMemo(() => {
    const selectedOrg = store.organization.selected;
    const selectedWhatsapp = selectedOrg?.whatsapp ? `+${selectedOrg?.whatsapp}` : "";
    const userEmail = store.user?.email || ""; // Get email from user store
    const userPlan = store.user?.plan || "trial"; // Default to trial if plan is undefined

    return {
      name: selectedOrg?.name || "",
      whatsapp: selectedWhatsapp || "",
      email: userEmail, // Add email field (read-only)
      // taxIdNumber: selectedOrg?.taxIdNumber || '',
      plan: userPlan.charAt(0).toUpperCase() + userPlan.slice(1),
      maxRoom: store.subscription?.data?.maxRoom || 0,
      nullEndDate: "Selamanya",
    };
  }, [store.organization.selected, store.user?.plan]);

  const _onSubmit = useCallback(
    async (settings) => {
      const updatedSettings = {
        name: settings.name,
        taxIdNumber: null,
        whatsapp: settings.whatsapp,
        isCompany: false, // Hardcoded since field is hidden
        currency: "IDR",
        locale: "id",
        addresses: [], // Using empty array instead of processed addresses
      };

      await onSubmit(updatedSettings);

      onSubmitted?.({
        isOrgNameChanged: updatedSettings.name !== initialValues.name,
      });
    },
    [onSubmit, onSubmitted, initialValues.name],
  );

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema(t)} onSubmit={_onSubmit}>
      {({ isSubmitting }) => {
        return (
          <Form autoComplete="off">
            <Section label={t("Landlord information")} className="shepherd-accountInfoSection">
              <TextField label={t("Name") + " *"} name="name" />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <PhoneField label={t("Whatsapp") + " *"} name="whatsapp" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={t("Email")}
                    name="email"
                    disabled={true} // Greyed out - cannot be updated by user
                    helperText={t("Email cannot be changed")}
                  />
                </Grid>
              </Grid>
            </Section>
            {/* <Section label={t("Subscription information")}>
              <Grid container spacing={2} alignItems="center" className="shepherd-accountSubscriptionSection">
                <Grid item xs={12} sm={4}>
                  <TextField label="Paket Berlangganan" name="plan" disabled />
                </Grid>
                <Grid item xs={12} sm={4}>
                  {store.user.trialEndDate ? (
                    <DateField
                      label="Aktif Sampai"
                      name="trialEndDate"
                      format="DD MMMM YYYY"
                      value={new Date(store.user.trialEndDate)}
                      disabled
                    />
                  ) : (
                    <TextField label="Aktif Sampai" name="nullEndDate" disabled fullWidth />
                  )}
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label={t("Max Room")}
                    name="maxRoom"
                    disabled
                    endAdornment={
                      <InputAdornment position="end">
                        <Button
                          size="small"
                          color="primary"
                          href={`https://api.whatsapp.com/send?phone=6281382586868&text=  Hi%2C%20email%20saya%20${encodeURIComponent(
                            initialValues.email
                          )}%2C%20ingin%20menambah%20langganan%20kamar%20di%20aplikasi%20SuperKos.`}
                          target="_blank"
                          rel="noopener noreferrer"
                          startIcon={<AddBox />}
                        >
                          {t("Upgrade")}
                        </Button>
                      </InputAdornment>
                    }
                    readOnly
                  />
                </Grid>
              </Grid>
            </Section> */}
            <SubmitButton size="large" label={!isSubmitting ? t("Save") : t("Saving")} />
          </Form>
        );
      }}
    </Formik>
  );
});

export default AccountSettings;
